import type { UiStrings } from "../types";

export const zh: UiStrings = {
  nav: {
    category: "分类",
    forYourWork: "工作工具",
    searchPlaceholder: "搜索300多种工具...",
    heroPlaceholder: "您在寻找什么？",
  },
  trustBadges: {
    noLogin: "使用工具无需登录",
    freeUsesDaily: "每天10次试用",
    filesNeverStored: "您的文件绝不会被存储",
    worksAnyDevice: "适用于任何设备",
    worksWhenAiBlocked: "不受公司AI使用政策限制",
    availableInLanguages: "支持多种语言",
  },
  common: {
    backToHome: "返回首页",
    home: "首页",
    signIn: "登录",
    account: "账户",
    contact: "联系我们",
    blog: "博客",
    shareThisTool: "分享此工具",
    download: "下载",
    copy: "复制",
    copied: "已复制",
  },
  footer: {
    tagline: "您的一站式在线效率平台。300多种专业工具、高级应用和工作流产品，满足日常所需。",
    company: "公司",
    about: "关于我们",
    blog: "博客",
    contact: "联系我们",
    pricing: "价格",
    privacyPolicy: "隐私政策",
    termsOfService: "服务条款",
    allTools: "所有工具",
    allRightsReserved: "版权所有。",
  },
  contact: {
    title: "联系我们",
    subtitle: "有问题、反馈，或遇到故障？我们很乐意为您提供帮助。",
    email: "电子邮箱",
    responseTime: "回复时间",
    responseTimeValue: "我们通常会在1-2个工作日内回复。",
    sendEmail: "给我们发邮件",
    billingNote: "如有账单相关问题，请附上与您账户关联的电子邮箱地址。",
    whoWeAreTitle: "FreeDailyPro 的运营方",
    whoWeAreBody: "FreeDailyPro 由 DreamUSA LLC 运营，这是一家独立运作的小型软件企业。背后并没有庞大的支持团队 -- 阅读并回复您邮件的人也是构建和维护工具的人，因此有时回复需要一到两天，而不是即时回复。",
    whatWeSupportTitle: "我们可以帮助的内容",
    whatWeSupportBody: "300+ 工具中任何一个的错误报告、功能请求、计费和订阅问题（包括取消和退款）、账户和登录问题，以及对哪些功能运作良好或不良的一般反馈。如果某个工具产生了不正确的结果，告知文件类型和大致出了什么问题有助于更快修复。",
  },
  home: {
    heroTitleLine1: "每一项专业任务。",
    heroTitleLine2: "一个浏览器平台",
    heroSubtitle: "使用工具、运行工作流、通过 API 和 MCP 构建，或者交给我们为您开发。",
    localSignalUsedTitle: "此设备上已使用",
    localSignalTryTitle: "试试这些工具",
    localSignalBadge: "本地运行 \u00b7 无需联网",
    localSignalUsedDesc: "个工具已在此设备上使用 \u2014 没有任何内容离开过您的浏览器",
    localSignalTryDesc: "个工具尚未在此设备上使用 \u2014 一切都直接在您的浏览器中运行",
    corporateSafeTitle: "企业安全适用",
    corporateSafeSubtitle: "无论贵公司的AI政策如何，FreeDailyPro都能正常使用",
    corporateSafeBlockedTitle: "完全屏蔽",
    corporateSafeBlockedDesc: "网络中不允许使用任何AI工具。FreeDailyPro的所有工具依然可用 \u2014 从不上传任何内容到服务器。",
    corporateSafeGovernedTitle: "受控访问",
    corporateSafeGovernedDesc: "仅允许通过经批准、审核过的工具使用AI。这里无需任何审批 \u2014 因为根本没有需要审核的外部服务器请求。",
    corporateSafeOpenTitle: "无限制",
    corporateSafeOpenDesc: "使用任何能完成工作的工具。由于无需上传或等待，FreeDailyPro自然更快。",
    corporateSafeCta: "查看完整的企业安全说明 \u2192",
    exploreToolkitTitle: "浏览工具库",
    exploreToolkitSubtitle: "300多种工具，分布在{catCount}个分类中 \u2014 选一个，或直接搜索。",
    forYourWorkTitle: "根据您真实的工作方式打造",
    forYourWorkSubtitle: "同样的专业工具，按您的实际工作分类整理",
    exploreTools: "浏览工具",
    seeAllRoles: "查看全部{count}个职业 \u2192",
    blogTitle: "来自博客",
    viewAllPosts: "查看所有文章",
    faqTitle: "有疑问吗？查看我们的常见问题",
    faqMoreLink: "还想了解更多？浏览完整常见问题 \u2192",
    toolkitProseTitle: "为日常工作打造的专业工具集，而不仅仅是偶尔用一次",
    closingCtaTitle: "别忘了添加快捷方式",
    closingCtaDesc: "添加一次，随时一键直达 \u2014 安装桌面快捷方式，或添加到手机主屏幕，FreeDailyPro即可像原生应用一样打开，无需在浏览器标签中查找。",
    categoriesLabel: "{count}个分类 \u2192",
    viewAllCategoriesLabel: "查看全部{count}个分类 \u2192",
    yourFavorites: "您的收藏",
    recentlyUsed: "最近使用",
    toolkitProsePara1: "FreeDailyPro将300多种日常工具集于一处 \u2014 PDF编辑、图片转换、视频剪辑、音频清理、文本格式化，以及数十种计算器 \u2014 让您无需为每项任务在不同网站间来回切换。大多数工具无需注册，基于文件的工具还包含每天10次免费使用。",
    toolkitProsePara2: "每个工具完全在您的浏览器中运行。当您压缩PDF或移除照片背景时，该文件绝不会离开您的设备 \u2014 不会被上传，不会在服务器上处理，也不会存储在任何地方，哪怕是临时存储。这不是限制，而是整体设计理念：更快的结果，即使文件敏感也无需担心。",
    toolkitProsePara3: "这种本地优先的方式也意味着，无论是在个人笔记本电脑、受限的办公设备，还是在有严格AI使用政策的网络上，FreeDailyPro的表现都完全一致 \u2014 因为根本没有需要IT部门审核的外部服务器请求。",
    toolkitProsePara4: "无论您需要为报告合并PDF、为商品列表调整图片大小、为社交媒体剪辑视频，还是快速计算房贷或税务，FreeDailyPro都致力于成为您每天都会用到的工具 \u2014 而不仅仅是偶尔想起才用的工具。",
    heroLaneToolsTitle: "面向单项任务的专业工具",
    heroLaneToolsDesc: "PDF、图片、视频等 —— 在浏览器中一步完成。",
    heroLaneToolsCta: "浏览工具",
    heroLanePremiumTitle: "适合大型任务的高级应用",
    heroLanePremiumDesc: "多步骤应用：文档、表单、规划工具、印刷与活动文件。",
    heroLanePremiumCta: "浏览应用",
    heroLaneWorkflowTitle: "工作流产品",
    heroLaneWorkflowDesc: "Book Writing Toolbox、Event Suite 等 —— 多个步骤，一个结果。",
    heroLaneWorkflowCta: "查看工作流产品",
    heroLaneApiTitle: "API 与 MCP",
    heroLaneApiDesc: "通过您自己的代码或 AI 代理调用相同的工具。",
    heroLaneApiCta: "打开开发者页面",
    heroLaneCustomTitle: "定制软件",
    heroLaneCustomDesc: "告诉我们您的需求。开发一次性收费，之后只需支付少量月度使用费。",
    heroLaneCustomCta: "申请开发",
  },
  install: {
    desktopTitle: "桌面快捷方式",
    desktopSubtitle: "一键点击，即时打开",
    mobileTitle: "移动应用",
    mobileSubtitle: "添加到主屏幕",
    addToHomeScreenTitle: "将FreeDailyPro添加到主屏幕",
    iosInstructions: "点击Safari中的分享图标，然后选择“添加到主屏幕”。",
    genericInstructions: "打开浏览器菜单，查找“添加到主屏幕”或“安装应用”。",
    desktopUnavailableTitle: "此浏览器不支持一键安装",
    desktopUnavailableDesc: "您仍可以收藏此页面，或将地址栏图标拖到桌面。",
    desktopSuccess: "快捷方式已创建！请查找FreeDailyPro图标。",
    mobileSuccess: "已添加！请在主屏幕上查找FreeDailyPro图标。",
  },
  toolPage: {
    proBadge: "Pro",
    usesRemainingToday: "今日还剩{count}次试用",
    whatThisToolDoes: "此工具的功能",
    proTips: "专业提示",
    continueWith: "接下来试试",
    moreFromCategory: "更多同类工具",
  },
  usageStrip: {
    freeUsesPerDay: "试用：每天{limit}次",
    remainingToday: "今日剩余{count}次",
    dayPassLabel: "无广告无限使用，1天通行证 $1",
    monthlyLabel: "无广告无限使用，月度通行证 $4.99",
    quickBuy: "快速购买",
  },
  platformsBanner: {
    title: "这个 API 实际上线在哪里",
    subtitle: "这不是一个写着“即将推出”的页面 -- 这些都是真实可用、今天就能订阅或连接的正式列表。",
    postmanDetail: "可直接运行的请求，文档齐全",
    rapidApiDetail: "通过 Rapid 市场按使用量计费订阅",
    mcpRegistryDetail: "正式列为 com.freedailypro/tools，{mcp} 个工具，一个接入点",
  },
  pricingBanner: {
    title: "透明定价",
    subtitle: "没有隐藏档位，没有意外限额 -- 每个套餐的费用和权益一目了然。",
    toolPricingTitle: "按使用量计费的工具定价",
    apiPricingTitle: "按使用量计费的 API 与 MCP 定价",
    freeLabel: "试用",
    freeToolDetail: "Professional Tools 每天 10 次，Premium Applications 每天 2 次",
    dayPassDetail: "$1/天 -- 无广告，无限使用",
    monthlyDetail: "$4.99/月 -- 无广告，无限使用",
    monthlySavingsNote: "比一个月买5次日通行证还便宜",
    freeApiDetail: "每月 20,000 次调用",
    premiumDetail: "$24/月 -- 200,000 次调用",
    ultraDetail: "$69/月 -- 750,000 次调用",
    megaDetail: "$129/月 -- 2,000,000 次调用 + 优先处理",
  },
  apiMcpBanner: {
    title: "现已支持 API 与 MCP",
    description: "直接从自己的代码中调用我们的 200+ 工具，或通过 MCP 连接 AI 代理 -- 同样的工具，服务端运行，适用于仅浏览器不够用的情况。",
    oneKey: "一个密钥适用于所有功能",
    restApiMcp: "REST API + MCP",
    anyLanguage: "任何语言，任何服务器",
    cta: "探索 API 与 MCP",
  },
  premiumApps: {
    title: "高级应用",
    subtitle: "真正的多步骤应用，而不仅仅是单一操作工具 -- 也可单独安装。",
    seeAll: "查看所有高级应用",
  },
  googleDrive: {
    openFromGoogle: "从 Google 云端硬盘打开",
    saveToGoogle: "保存到 Google 云端硬盘",
    signingIn: "正在打开 Google 登录...",
    fetching: "正在从 Google 云端硬盘获取文件...",
    saving: "正在保存到 Google 云端硬盘...",
    saved: "已保存到 Google 云端硬盘",
    viewInDrive: "在云端硬盘中查看",
    popupBlocked: "浏览器拦截了 Google 登录窗口。请允许本网站的弹出窗口，然后重试。",
    cancelled: "Google 登录在完成前被关闭。未打开或保存任何内容。",
    denied: "未允许访问 Google 云端硬盘，因此未打开或保存任何内容。请重试并允许访问您选择的文件。",
    loadFailed: "无法连接 Google。请检查网络或内容拦截器后重试。",
    network: "与 Google 云端硬盘的连接中断。请重试。",
    tooLarge: "该文件太大，无法在浏览器中打开。",
    api: "Google 云端硬盘未能完成操作。请重试。",
    largeFile: "此文件超过 50 MB，可能耗时较长或耗尽浏览器内存。",
    privacyNote: "文件只在您的浏览器与 Google 之间传输，不会发送到我们的服务器。",
  },
};
